import Rx from 'rxjs/Rx';

class ProductWalletStore {
  constructor(TransactionApiService, CustomerApiService, SessionService) {
    'ngInject';

    this.TransactionApiService = TransactionApiService;
    this.CustomerApiService = CustomerApiService;
    this.SessionService = SessionService;

    // $ denotes that the property is an observable.
    this.currency$ = SessionService.session.map(session => session.currency);
  }

  /**
   * @returns {Observable}
   */
  getCustomerProducts() {
    return Rx.Observable.fromPromise(this.CustomerApiService.getProducts());
  }

  /**
   * @returns {Observable}
   */
  getCurrency() {
    return this.SessionService.session.map(session => session ? session.currency : null);
  }

  transfer(payload) {
    return this.TransactionApiService.transfer(payload);
  }
}

export default ProductWalletStore;



// WEBPACK FOOTER //
// ./client/app/pages/customer/productwallet/service/product-wallet.store.js